export default "__VITE_ASSET__yKjQF8N9__"